//@flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import getter from 'dibs-object-getter';

import styles from './ProfileHeaderBreadcrumbs.scss';

import type { ProfileHeaderBreadcrumbs_tradeFirm as TradeFirmType } from './__generated__/ProfileHeaderBreadcrumbs_tradeFirm.graphql';

type Props = {
    tradeFirm: ?TradeFirmType,
};

export const ProfileHeaderBreadcrumbsComponent = (props: Props) => {
    const name = getter(props.tradeFirm).value('name');

    return (
        <div className={styles.wrapper}>
            <a className={styles.breadcrumbItem} href="/design-firms/">
                <FormattedMessage
                    id="abt.designProfile.header.rootLabel"
                    defaultMessage="Design Firms"
                />
            </a>
            <span className={styles.breadcrumbItem}>/</span>
            <span className={styles.breadcrumbItem}>{name}</span>
        </div>
    );
};

export const ProfileHeaderBreadcrumbs = createFragmentContainer(ProfileHeaderBreadcrumbsComponent, {
    tradeFirm: graphql`
        fragment ProfileHeaderBreadcrumbs_tradeFirm on TradeFirmType {
            name
        }
    `,
});
